import React from "react";

// Circular check icon for provider PIN verification
const ProviderPinVerifyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="22"
    height="22"
  >
    {/* White circular background with blue border */}
    <circle
      cx="12"
      cy="12"
      r="9"
      fill="#ffffff"
      stroke="#2563eb"
      strokeWidth="2"
    />
    {/* Blue check mark */}
    <path
      d="M9 12.75 11.25 15 15 9.75"
      fill="none"
      stroke="#2563eb"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ProviderPinVerifyIcon;

